import type { QueryKey } from '@tanstack/react-query';
import { UserCacheKeys } from 'types/cacheKeys.types';
import { isExpert } from 'utils/constants';
import { getCustomerIdFromPath } from 'utils/helpers';

/**
 * React Query key for `GET v2/users/minfin/session` (`getBEFinSession`).
 * In expert mode the session is for the selected client (x-on-behalf-of); the key
 * includes the same customer id as `useGetCurrentCustomerData` to avoid stale data
 * when switching clients. Web keeps a single global key.
 */
export function getBEFinSessionQueryKey(): QueryKey {
  if (isExpert) {
    return [UserCacheKeys.BEFinSession, getCustomerIdFromPath()];
  }
  return [UserCacheKeys.BEFinSession];
}
